import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

const GridActionButtons = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2px',
        '& > *': {
          ml: 1 / 2,
          mb: 1 / 2,
        },
      }}
    >
      <Button
        variant='contained'
        color='primary'
        startIcon={<AddCircleIcon />}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component={Link as any}
        to={RoutesEnum.CreateSendingOrder}
        disableElevation
      >
        Beställ nytt utskick
      </Button>
    </Box>
  );
};

export default GridActionButtons;
